import {Dict} from "mixpanel-browser";

export class Mixpanel {
    track = (event: string, props ?: Dict, callback ?: () => void) => {
        (window as any).mixpanel.track(event, props, callback);
    }
}

export default new Mixpanel();